<template>
    <div>
        <div class="style-catalogues-container-xl">
            <div
                role="button"
                class="d-flex justify-content-between align-items-center"
                @click="toggleItem('style')"
            >
                <span>
                    <img src="@/assets/services/vs/style-catalogue-icon.svg" alt="" />
                    <span class="ms-3 fsz-12 primary-color">
                        Choose your favorite <strong> Style</strong>, and we’ll stage it.
                    </span>
                </span>
                <span>
                    <img
                        v-show="expandStyleCataloguesMenu"
                        src="@/assets/services/collapse-icon.svg"
                        alt=""
                    />
                    <img
                        v-show="!expandStyleCataloguesMenu"
                        src="@/assets/services/expand.svg"
                        alt=""
                    />
                </span>
            </div>
            <CollapseTransition>
                <div
                    v-if="expandStyleCataloguesMenu"
                    class="style-catalogues-items-wrapper-xl mt-4"
                >
                    <div
                        v-for="(catalogue, index) in styleCategory"
                        :key="index"
                        class="style-catalogues-items-outer-container-xl"
                        @mouseenter="indexOfHoverItem = index"
                        @mouseleave="
                            handleFindIndex(catalogue.id) >= 0
                                ? (indexOfHoverItem = index)
                                : (indexOfHoverItem = null)
                        "
                    >
                        <div
                            role="button"
                            class="style-catalogues-items-container-xl me-2"
                            @click="handleSelectStyle(catalogue)"
                        >
                            <div class="style-catalogues-items-poster-xl">
                                <img v-lazy="catalogueSrc(catalogue.src)" alt="" />
                            </div>

                            <div class="style-catalogues-items-title-xl">
                                {{ catalogue.name }}
                            </div>
                            <div :class="[accentLayerClass(catalogue.id)]"></div>

                            <div
                                class="style-catalogues-items-checkbox-container-xl"
                                :class="[
                                    indexOfHoverItem === index || handleFindIndex(catalogue.id) >= 0
                                        ? 'opacity-1'
                                        : 'opacity-0',
                                ]"
                            >
                                <div>
                                    <!-- <input
                                        :id="index"
                                        ref="styleCheckbox"
                                        :checked="selectedStyleId.includes(catalogue.id)"
                                        type="checkbox"
                                        class="style-catalogues-items-checkbox-input-xl"
                                    /> -->
                                    <span :class="[styleCategoryCheckbox(catalogue.id)]"></span>
                                </div>
                                <!-- <div
                                    class="style-catalogues-items-checkbox-expand-icon-xl"
                                    @click="showStyleModal(catalogue.id)"
                                >
                                    <img
                                        src="@/assets/services/expand-catalogues-icon.svg"
                                        alt=""
                                    />
                                </div> -->
                            </div>
                        </div>
                        <transition
                            enter-active-class="animate__animated animate__fadeInDown"
                            leave-active-class="animate__animated animate__fadeOutDown"
                        >
                            <div
                                v-if="filterSelectedStyles(catalogue).numOfOutput > 0"
                                class="d-flex align-items-center flex-wrap justify-content-center"
                            >
                                <span class="fsz-12 secondary-color m-right-1 fw-bold"
                                    >No. of Output</span
                                >
                                <span class="border bg-light rounded px-2">
                                    <button
                                        :disabled="filterSelectedStyles(catalogue).numOfOutput <= 1"
                                        class="me-2"
                                        role="button"
                                        @click="
                                            decNumOfOutputs(
                                                filterSelectedStyles(catalogue).id,
                                                index
                                            )
                                        "
                                    >
                                        <img src="../assets/minus-icon.svg" alt="" />
                                    </button>
                                    <span class="me-2 fw-bold">{{
                                        filterSelectedStyles(catalogue).numOfOutput > 0
                                            ? filterSelectedStyles(catalogue).numOfOutput
                                            : 0
                                    }}</span>
                                    <button
                                        class=""
                                        role="button"
                                        @click="
                                            incNumOfOutputs(
                                                filterSelectedStyles(catalogue).id,
                                                index
                                            )
                                        "
                                    >
                                        <img src="../assets/plus-icon.svg" alt="" />
                                    </button>
                                </span>
                            </div>
                        </transition>
                    </div>
                </div>
            </CollapseTransition>
        </div>
        <div class="style-catalogues-notification-container-xl">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import Notification from '@/components/snacks/index.vue';
import StyleModal from '@/components/modals/style-modals.vue';
import baseApiAddress from '@/axios.config';

export default {
    components: {
        CollapseTransition,
        Notification,
    },
    data() {
        return {
            // expandStyleCataloguesMenu: false,
            selectedStyleId: [],
            showNotification: false,
            notificationMessage: '',
            notificationStatus: '',
            indexOfHoverItem: null,
        };
    },
    computed: {
        ...mapGetters(['styleCategory', 'selectedStyles', 'selectedRoomTypes']),
        ...mapState({
            ...mapState({
                expandStyleCataloguesMenu: (state) => state.vsStore.expandStyleCataloguesMenu,
            }),
        }),
    },
    watch: {
        selectedStyleId: function () {
            this.$store.commit('checkSelectedStyleChanges', true);
        },
    },
    mounted() {
        this.selectedStyles.map((item) => {
            this.selectedStyleId.push(item.id);
        });
    },
    methods: {
        catalogueSrc(src) {
            return `${process.env.VUE_APP_BASE_IMAGE_SRC}${src.split('.')[0]}_100.${
                src.split('.')[1]
            }`;
        },

        styleCategoryCheckbox(id) {
            return this.handleFindIndex(id) >= 0
                ? 'style-catalogues-items-checkbox-bg-image-xl'
                : 'style-catalogues-items-checkbox-bg-color-xl';
        },
        accentLayerClass(id) {
            return this.handleFindIndex(id) >= 0
                ? 'style-catalogues-items-accent-layer-show-xl'
                : 'style-catalogues-items-accent-layer-hide-xl';
        },

        async showStyleModal(id) {
            try {
                this.$store.commit('handleVsLoadingXS', true);
                const { status, data } = await baseApiAddress({
                    method: 'get',
                    url: `/catalogs/style-category/catalogs?style_id=${id}`,
                });
                if (status >= 200 && status < 300) {
                    this.$store.commit('handleVsLoadingXS', false);

                    this.$modal.show(
                        StyleModal,
                        {
                            images: data.data,
                        },
                        {
                            name: 'style-modal',
                            width: '1120px',
                            height: 'auto',
                            styles: {
                                borderRadius: '24px',
                                boxShadow: '0px 4px 13px rgba(0, 0, 0, 0.15)',
                            },
                        }
                    );
                }
            } catch (error) {
                this.$store.commit('handleVsLoadingXS', false);
            }
        },
        toggleItem(type) {
            this.$store.commit('HANDLE_STYLE_CATALOGUES', type);

            // this.expandStyleCataloguesMenu = !this.expandStyleCataloguesMenu;
        },

        handleSelectStyle(style) {
            let numOfOutput = 0;
            this.selectedStyles.map((style) => {
                numOfOutput += style.numOfOutput;
            });

            if (this.selectedRoomTypes.length > 0) {
                let payload = {};
                if (this.handleFindIndex(style.id) < 0) {
                    if (numOfOutput > 4) {
                        this.handleNotification(
                            'warning',
                            'We can currently only accept five outputs for each photo'
                        );
                        return;
                    }
                    payload.type = 'add';
                    payload.style = {
                        _id: '',
                        id: style.id,
                        name: style.name,
                        numOfOutput: 1,
                    };
                    this.$store.commit('HANDLE_SELECTED_STYLE', payload);
                    return;
                }

                payload.type = 'remove';
                payload.styleIndex = this.handleFindIndex(style.id);
                this.$store.commit('HANDLE_SELECTED_STYLE', payload);
            } else {
                this.handleNotification('warning', 'Please select a Roomtype first!');
            }
        },
        handleFindIndex(id) {
            const styleIndex = this.selectedStyles.findIndex((style) => {
                return style.id === id;
            });
            return styleIndex;
        },

        decNumOfOutputs(id, index) {
            const dispatchData = {
                id,
                type: 'decrease',
            };
            this.$store.commit('handleNumOfOutputs', dispatchData);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        incNumOfOutputs(id, index) {
            let numOfOutput = 0;
            this.selectedStyles.map((style) => {
                numOfOutput += style.numOfOutput;
            });
            const [selectedStyle] = this.selectedStyles.filter((style) => {
                return style.id === id;
            });
            if (numOfOutput > 4) {
                this.handleNotification(
                    'warning',
                    'We can currently only accept five outputs for each photo'
                );
                return;
            }
            if (selectedStyle.numOfOutput >= 2) {
                this.handleNotification(
                    'warning',
                    'We can currently only accept two outputs for each style'
                );

                return;
            }
            const dispatchData = {
                id,
                type: 'increase',
            };
            this.$store.commit('handleNumOfOutputs', dispatchData);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        filterSelectedStyles(catalogue) {
            const [filteredStyle] = this.selectedStyles.filter((style) => {
                return style.name === catalogue.name;
            });
            if (filteredStyle) {
                return filteredStyle;
            }
            return 0;
        },
        handleNotification(status, message) {
            this.showNotification = true;
            this.notificationStatus = status;
            this.notificationMessage = message;
            setTimeout(() => {
                this.showNotification = false;
            }, 3500);
        },
    },
};
</script>

<style lang="scss" scoped>
button {
    border: none;
    outline: none;
    background-color: transparent;
}

.style-catalogues {
    &-container-xl {
        border: 2px solid #ededed;
        border-radius: 16px;
        padding: 16px 20px;
        margin-top: 16px;
    }
    &-items {
        &-wrapper-xl {
            display: grid;
            grid-template-columns: repeat(4, calc((100% - 48px) / 4));
            column-gap: 16px;
        }
        &-outer-container-xl {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 32px;
        }
        &-container-xl {
            position: relative;
            width: 100%;
            height: 100px;
            margin-bottom: 8px;
        }
        &-poster-xl {
            @include centerByFlex;
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
                border-radius: 8px;
                object-fit: cover;
            }
        }
        &-title-xl {
            width: 100%;
            height: 38px;
            line-height: 38px;
            position: absolute;
            z-index: 1;
            bottom: 0;
            text-align: center;
            color: $White-Color;
            font-weight: bold;
            background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
            opacity: 0.88;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
        &-checkbox {
            &-container-xl {
                width: 24px;
                height: 100%;
                position: absolute;
                top: 0px;
                right: 8px;
                z-index: 3;
                padding-top: 8px;
                transition: opacity 0.8s;
            }
            &-input-xl {
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;
                width: 24px;
                height: 24px;
                opacity: 0;
            }
            &-bg-image-xl {
                background: url('~@/assets/services/tick.svg');
                border-radius: 8px;
                position: absolute;
                background-position: center;
                background-size: contain;
                box-shadow: $Active-Shadow;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
            &-bg-color-xl {
                width: 24px;
                height: 24px;
                background-color: $White-Color;
                box-shadow: $Black-Shadow;
                border-radius: 8px;
                position: absolute;
                cursor: pointer;
            }
            &-expand-icon-xl {
                @include centerByFlex;
                position: absolute;
                bottom: 8px;
                width: 24px;
                height: 24px;
                z-index: 5;
                border-radius: 50%;
                background-color: rgba($color: #fff, $alpha: 0.75);
                box-shadow: $Black-Shadow;
                cursor: pointer;
            }
        }
        &-accent-layer {
            &-show-xl {
                opacity: 1;
                width: 100%;
                // max-width: 176px;
                height: 100px;
                position: absolute;
                top: 0;
                margin-bottom: 8px;
                background-color: rgba($color: #707ac9, $alpha: 0.5);
                border-radius: 8px;
                z-index: 1;
                transition: opacity 0.7s;
            }
            &-hide-xl {
                opacity: 0;
                transition: all 5s;
            }
        }
    }
    &-notification {
        &-container-xl {
            position: fixed;
            bottom: 20px;
            right: 20px;
            z-index: 10;
        }
    }
}
img[lazy='loading'] {
    background-color: $Gray-Color;
    width: 48px;
    height: 48px;
}
</style>
